import React, { useState } from 'react'
import ReactPlayer from 'react-player'

import { CollectionVideoTypes } from '../../../pages/NewCollectionsPage/NewCollectionPage.types'
import styles from './CollectionVideo.module.scss'
import IconMuted from './IconMuted'

export default function CollectionVideo({
  props,
}: {
  props: CollectionVideoTypes
}) {
  const [muted, setMuted] = useState<boolean>(true)

  return (
    <div className={styles.wrapper}>
      <ReactPlayer
        url={props.src}
        width='100%'
        height='100%'
        playing
        muted={muted}
        loop
        playsinline
      />
      {props.mutedControl && (
        <button
          className={[
            styles['button-muted'],
            styles[muted ? 'button-muted--on' : 'button-muted--off'],
            props.topMutedButton ? styles['button-muted--top'] : '',
          ].join(' ')}
          onClick={() => {
            setMuted(!muted)
          }}
        >
          <IconMuted muted={muted} />
        </button>
      )}
    </div>
  )
}
